import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function RefreshEligibilityButton({
  onRefresh,
  isRefreshing = false
}) {
  return /*#__PURE__*/_jsx(UIIconButton, {
    disabled: isRefreshing,
    onClick: () => onRefresh(),
    size: "small",
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.moveToSupportCard.tooltip.refresh"
    }),
    use: "link",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "refresh"
    })
  });
}